function promptAmimation(nodeEl, textToAnimate, deletetText = true){
nodeEl.current.style.display  = "block";
nodeEl.current.innerText = '';
const arrayWords = textToAnimate;

let x = 0;
let s = arrayWords.length;
let s1 = -1;
let s2 = -1;

    s1 = setInterval(() => {       
        if(arrayWords.length === x){
            clearInterval(s1)
        }else{
            nodeEl.current.innerHTML += arrayWords.charAt(x++)        
            console.log(nodeEl.current.innerHTML);            
        }
    }, 100);

    if(deletetText)
    setTimeout(() => {
        s2 = setInterval(() => {
            if(s === 0){
                clearInterval(s2)
                nodeEl.current.innerText = ''
            }
            else{
                const cur_dec_el = nodeEl.current
                nodeEl.current.innerText = cur_dec_el.innerText.slice(0, --s)
                clearInterval()
            }
        },  100);
    }, 5000);
} 

export default promptAmimation;